export default __webpack_public_path__ + "static/media/dianoiva_3.bdd5b8a9.jpg";